import React, { ReactElement } from 'react'

function StepTitle({
  children,
  title,
}: {
  children: ReactElement
  title: string
}): ReactElement {
  return (
    <div className="mb2 mb35md dFlex flexWrap justifyContentBetween">
      <div className="mb15 mb0md">
        <h2 className="fontSize1md mb05 textPrimary">{title}</h2>
        <p className="fontSizeXs textPrimary fontWeightBold">
          * Champs obligatoires
        </p>
      </div>
      {children}
    </div>
  )
}

export default StepTitle
